import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Dodge extends Modifier {
  static readonly baseTitle = 'Dodge';
  static readonly baseText =
    'When attacked, if the damage is greater than half your current Health, negate it and remove 1 stack. Otherwise, take full damage and remove 1 stack. Temporary.';
  static readonly baseIcon = 'dodge';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties initialized from static values
  title = Dodge.baseTitle;
  text = Dodge.baseText;
  icon = Dodge.baseIcon;
  tags = [...Dodge.baseTags];
  priority = Dodge.basePriority;

  damageIn(damage: Damage) {
    const currentHealth = this.owner.healthCurrent; // or this.getCurrentHealth()
    const halfHealthThreshold = Math.ceil(currentHealth / 2);

    if (damage.value >= halfHealthThreshold) {
      // Large attack → dodge completely
      damage.value = 0;
    } else {
      // Small hit → take full damage, still consume one dodge
    }
    this.removeStacks(1);
  }

  startTurn() {
    this.removeStacks(this.stacks);
  }

  modifierAdd(type: StatusEffect, stacks: number) {
    if (type === StatusEffect.Snared) {
      let difference = this.stacks - stacks;
      this.removeStacks(Math.min(this.stacks, stacks));

      if (difference >= 0) {
        stacks = 0;
      } else {
        stacks = Math.abs(difference);
      }
    }
    return stacks;
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Dodge, Dodge);
